module.exports = __webpack_public_path__ + "static/media/r4.5538cb02.jpg";